import ShippingMobileList from '@/components/ShippingMobile/ShippingMobileList'
import ShippingMobileForm from '@/components/ShippingMobile/ShippingMobileForm'

let ShippingMobileRouter = [{
  path: '/shipping_mobile',
  name: 'ShippingMobileList',
  component: ShippingMobileList,
  meta: {
    title: 'Expéditions',
    requiresAuth: true,
    authorizations: ['shipping_index', 'mobile_access']
  }
}, {
  path: '/shipping_mobile/:id/edit/:referer',
  name: 'ShippingMobileEditReferer',
  component: ShippingMobileForm,
  meta: {
    title: 'Modifier une expédition',
    requiresAuth: true,
    authorizations: ['shipping_edit', 'mobile_access']
  }
}, {
  path: '/shipping_mobile/:id/edit',
  name: 'ShippingMobileEdit',
  component: ShippingMobileForm,
  meta: {
    title: 'Modifier une expédition',
    requiresAuth: true,
    authorizations: ['shipping_edit', 'mobile_access']
  }
}]

export default ShippingMobileRouter



// WEBPACK FOOTER //
// ./src/components/ShippingMobile/router.js